import { getGlyphRuneFromSearchResultType } from '@/lib/glyph-markers'
import { setSearchPinFeatures } from '@/services/map-service'
import { point } from '@turf/turf'
import type { Feature, Point, Position } from 'geojson'

interface SearchResultPinProperties {
  id: string
  name: string
  icon: string
  selectable: boolean
  index: number
}

export type SearchResultPin = Feature<Point, SearchResultPinProperties>

/** Add a set of SearchResultPins to the map */
export const displaySearchResultPins = (pins: SearchResultPin[]) => {
  setSearchPinFeatures(pins)
}

/** Remove all SearchResultPins from the map */
export const clearSearchResultPins = () => {
  setSearchPinFeatures([])
}

/**
 * Generate a SearchResultPin feature from search result item data.
 * The parameters of this function are intentionally generic in
 * order to support search result data from multiple sources
 * */
export const generatePinFeatureFromSearchResult = ({
  id,
  name,
  type,
  location,
  index,
}: {
  id: string
  name: string
  type: string
  location: Position
  index: number
}): SearchResultPin => {
  const properties = {
    id,
    name,
    icon: getGlyphRuneFromSearchResultType(type),
    selectable: true,
    index,
  }

  const feature = point(location, properties)
  feature.id = id

  return feature
}
